import { Atom, Molecule } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
    border-radius: 4px;
    border: 1px solid #e4e6eb;
    margin-right: 30px;
    cursor: pointer;
    color: #aaa;
`

const labelTemplate = styled.label`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`


export default Molecule({
    template,
    type: 'button',
    atoms: [
        {
            component: Atom({ type: 'upload', dataType: '', template: labelTemplate }),
            name: 'Label',
            displayValue: ({ label }) => label
        }
    ]
})
